import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Modal from '../modal/Modal';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import FormHelperText from '@mui/material/FormHelperText';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { axiosClient } from '../AxiosClient';

const ButtonPrincipal = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    '&:hover': {
        backgroundColor: '#BADEC1',
    },
});


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const ButtonEdit = styled(Button)({
    color: '#161e55',
    '&:hover': {
        color: '#BADEC1',
    },
});

const ButtonAdd = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    color: '#ffff',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
});

const TextMessage = styled(FormHelperText)({
    color: 'red'
});

export default function Scores() {
    
    const [segmentations, setSegmentations] = useState([]);
    const [isModal, setIsModal] = useState(false);
    const [editingIndex, setEditingIndex] = useState(null);
    
    const [scoreMinimo, setScoreMinimo] = useState('');
    const [scoreMaximo, setScoreMaximo] = useState('');
    const [fondoGarantiaConsumo, setFondoGarantiaConsumo] = useState('');
    const [fondoGarantiaConsumoBajoMonto, setFondoGarantiaConsumoBajoMonto] = useState('');
    const [tasaInteresConsumo, setTasaInteresConsumo] = useState('');
    const [tasaInteresConsumoBajoMonto, setTasaInteresConsumoBajoMonto] = useState('');
    
    const [errorScoreMinimo, setErrorScoreMinimo] = useState(false);
    const [errorScoreMaximo, setErrorScoreMaximo] = useState(false);
    const [errorFondoGarantiaConsumo, setErrorFondoGarantiaConsumo] = useState(false);
    const [errorFondoGarantiaConsumoBajoMonto, setErrorFondoGarantiaConsumoBajoMonto] = useState(false);
    const [errorTasaInteresConsumo, setErrorTasaInteresConsumo] = useState(false);
    const [errorTasaInteresConsumoBajoMonto, setErrorTasaInteresConsumoBajoMonto] = useState(false);
    
    const [errorMessageScoreMinimo, setErrorMessageScoreMinimo] = useState('');
    const [errorMessageScoreMaximo, setErrorMessageScoreMaximo] = useState('');
    const [errorMessageFondoGarantiaConsumo, setErrorMessageFondoGarantiaConsumo] = useState('');
    const [errorMessageFondoGarantiaConsumoBajoMonto, setErrorMessageFondoGarantiaConsumoBajoMonto] = useState('');
    const [errorMessageTasaInteresConsumo, setErrorMessageTasaInteresConsumo] = useState('');
    const [errorMessageTasaInteresConsumoBajoMonto, setErrorMessageTasaInteresConsumoBajoMonto] = useState('');
    
    const [tasaInteresConsumoType, setTasaInteresConsumoType] = useState('');
    const [tasaInteresConsumoBajoMontoType, setTasaInteresConsumoBajoMontoType] = useState('');
    const [tasaInteresConsumoPersonalizado, setTasaInteresConsumoPersonalizado] = useState('');
    const [tasaInteresConsumoBajoMontoPersonalizado, setTasaInteresConsumoBajoMontoPersonalizado] = useState('');
    
    const [tasasInteres, setTasasInteres] = useState(['5', '10', '15', '20', '25', '30', '35', '40', 'Personalizado']);
    const [tasaInteresConsumoParametro, setTasaInteresConsumoParametro] = useState(null);
    const [tasaInteresConsumoBajoMontoParametro, setTasaInteresConsumoBajoMontoParametro] = useState(null);
    
    const [experian, setExperian] = useState('sintesis-pdf');
    const [hasSearched, setHasSearched] = useState(false);
    
    const [isSnackbar, setIsSnackbar] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('');
    const [isBackdrop, setIsBackdrop] = useState(false);

    useEffect(() => {
        if (localStorage.getItem('userUuid') == null) {
            window.location = '/admin';
        }
        
        // Cargar parámetros y segmentaciones por defecto al entrar a la vista
        getParameters();
        getSegmentationsByExperian();
    }, []);

    const getParameters = () => {
        axiosClient.get('/v1/parameters')
            .then(response => {
                if (response.status === 200 && response.data) {
                    const tasaConsumo = response.data.tasaInteresConsumo ? (response.data.tasaInteresConsumo * 100).toFixed(2) : null;
                    const tasaBajoMonto = response.data.tasaInteresConsumoBajoMonto ? (response.data.tasaInteresConsumoBajoMonto * 100).toFixed(2) : null;
                    
                    if (tasaConsumo) {
                        setTasaInteresConsumoParametro(tasaConsumo);
                        const nuevasTasas = ['5', '10', '15', '20', '25', '30', '35', '40', 'Personalizado'];
                        nuevasTasas.unshift(`Parámetro (${tasaConsumo}%)`);
                        setTasasInteres(nuevasTasas);
                    }
                    
                    if (tasaBajoMonto) {
                        setTasaInteresConsumoBajoMontoParametro(tasaBajoMonto);
                    }
                }
            })
            .catch(error => {
                console.log("Error fetching parameters: " + error.message);
            });
    };

    const getSegmentations = () => {
        setIsBackdrop(true);
        axiosClient.get('/v1/score-segmentations/all')
            .then(response => {
                if (response.status === 200 && response.data && response.data.length > 0) {
                    // Convertir los valores según el formato que vienen del backend
                    const formattedData = response.data.map(seg => ({
                        ...seg,
                        interesConsumoPersonalizado: seg.interesConsumoPersonalizado !== undefined ? seg.interesConsumoPersonalizado : false,
                        interesConsumoBajoMontoPersonalizado: seg.interesConsumoBajoMontoPersonalizado !== undefined ? seg.interesConsumoBajoMontoPersonalizado : false,
                    }));
                    setSegmentations(formattedData);
                } else {
                    setSegmentations([]);
                }
                setIsBackdrop(false);
            })
            .catch(error => {
                console.log("Error fetch: " + error.message);
                setSegmentations([]);
                setIsBackdrop(false);
            });
    };

    const handleChangeExperian = (e) => {
        const newValue = e.target.value;
        setExperian(newValue);
        setSegmentations([]);
        setHasSearched(false);
        setErrorSegmentationIndex(null);
        
        // Hacer la consulta automáticamente
        if (newValue) {
            setIsBackdrop(true);
            setHasSearched(true);
            axiosClient.get(`/v1/score-segmentations/experian/${newValue}`)
                .then(response => {
                    if (response.status === 200 && response.data && response.data.length > 0) {
                        const formattedData = response.data.map(seg => ({
                            ...seg,
                            interesConsumoPersonalizado: seg.interesConsumoPersonalizado !== undefined ? seg.interesConsumoPersonalizado : false,
                            interesConsumoBajoMontoPersonalizado: seg.interesConsumoBajoMontoPersonalizado !== undefined ? seg.interesConsumoBajoMontoPersonalizado : false,
                        }));
                        setSegmentations(formattedData);
                        setMessage('Segmentaciones cargadas exitosamente');
                        setSeverity('success');
                        setIsSnackbar(true);
                    } else {
                        setSegmentations([]);
                        setMessage('No se encontraron segmentaciones para este tipo de Experian');
                        setSeverity('info');
                        setIsSnackbar(true);
                    }
                    setIsBackdrop(false);
                })
                .catch(error => {
                    console.log("Error fetch: " + error.message);
                    setSegmentations([]);
                    setIsBackdrop(false);
                    setMessage('Error al cargar las segmentaciones. Por favor intenta de nuevo');
                    setSeverity('error');
                    setIsSnackbar(true);
                });
        }
    };

    const getSegmentationsByExperian = () => {
        if (!experian) {
            setMessage('Por favor selecciona un tipo de segmentación de Experian');
            setSeverity('warning');
            setIsSnackbar(true);
            return;
        }

        setIsBackdrop(true);
        setHasSearched(true);
        axiosClient.get(`/v1/score-segmentations/experian/${experian}`)
            .then(response => {
                if (response.status === 200 && response.data && response.data.length > 0) {
                    // Convertir los valores según el formato que vienen del backend
                    const formattedData = response.data.map(seg => ({
                        ...seg,
                        interesConsumoPersonalizado: seg.interesConsumoPersonalizado !== undefined ? seg.interesConsumoPersonalizado : false,
                        interesConsumoBajoMontoPersonalizado: seg.interesConsumoBajoMontoPersonalizado !== undefined ? seg.interesConsumoBajoMontoPersonalizado : false,
                    }));
                    setSegmentations(formattedData);
                    setMessage('Segmentaciones cargadas exitosamente');
                    setSeverity('success');
                    setIsSnackbar(true);
                } else {
                    setSegmentations([]);
                    setMessage('No se encontraron segmentaciones para este tipo de Experian');
                    setSeverity('info');
                    setIsSnackbar(true);
                }
                setIsBackdrop(false);
            })
            .catch(error => {
                console.log("Error fetch: " + error.message);
                setSegmentations([]);
                setIsBackdrop(false);
                setMessage('Error al cargar las segmentaciones. Por favor intenta de nuevo');
                setSeverity('error');
                setIsSnackbar(true);
            });
    };

    const validateScoreMinimo = (value) => {
        if (!value) {
            setErrorScoreMinimo(true);
            setErrorMessageScoreMinimo('Este campo es requerido');
            return false;
        }
        if (isNaN(value)) {
            setErrorScoreMinimo(true);
            setErrorMessageScoreMinimo('Debe ser un número');
            return false;
        }
        if (scoreMaximo && parseInt(value) >= parseInt(scoreMaximo)) {
            setErrorScoreMinimo(true);
            setErrorMessageScoreMinimo('Debe ser menor que el score máximo');
            return false;
        }
        setErrorScoreMinimo(false);
        setErrorMessageScoreMinimo('');
        return true;
    };

    const validateScoreMaximo = (value) => {
        if (!value) {
            setErrorScoreMaximo(true);
            setErrorMessageScoreMaximo('Este campo es requerido');
            return false;
        }
        if (isNaN(value)) {
            setErrorScoreMaximo(true);
            setErrorMessageScoreMaximo('Debe ser un número');
            return false;
        }
        if (scoreMinimo && parseInt(value) <= parseInt(scoreMinimo)) {
            setErrorScoreMaximo(true);
            setErrorMessageScoreMaximo('Debe ser mayor que el score mínimo');
            return false;
        }
        setErrorScoreMaximo(false);
        setErrorMessageScoreMaximo('');
        return true;
    };

    const validateFondoGarantiaConsumo = (value) => {
        if (!value) {
            setErrorFondoGarantiaConsumo(true);
            setErrorMessageFondoGarantiaConsumo('Este campo es requerido');
            return false;
        }
        const numValue = parseFloat(value);
        if (isNaN(numValue)) {
            setErrorFondoGarantiaConsumo(true);
            setErrorMessageFondoGarantiaConsumo('Debe ser un número');
            return false;
        }
        if (numValue < 0 || numValue > 100) {
            setErrorFondoGarantiaConsumo(true);
            setErrorMessageFondoGarantiaConsumo('Debe estar entre 0 y 100');
            return false;
        }
        setErrorFondoGarantiaConsumo(false);
        setErrorMessageFondoGarantiaConsumo('');
        return true;
    };

    const validateFondoGarantiaConsumoBajoMonto = (value) => {
        if (!value) {
            setErrorFondoGarantiaConsumoBajoMonto(true);
            setErrorMessageFondoGarantiaConsumoBajoMonto('Este campo es requerido');
            return false;
        }
        const numValue = parseFloat(value);
        if (isNaN(numValue)) {
            setErrorFondoGarantiaConsumoBajoMonto(true);
            setErrorMessageFondoGarantiaConsumoBajoMonto('Debe ser un número');
            return false;
        }
        if (numValue < 0 || numValue > 100) {
            setErrorFondoGarantiaConsumoBajoMonto(true);
            setErrorMessageFondoGarantiaConsumoBajoMonto('Debe estar entre 0 y 100');
            return false;
        }
        setErrorFondoGarantiaConsumoBajoMonto(false);
        setErrorMessageFondoGarantiaConsumoBajoMonto('');
        return true;
    };

    const validateTasaInteres = (value, isBajoMonto = false) => {
        if (!value) {
            if (isBajoMonto) {
                setErrorTasaInteresConsumoBajoMonto(true);
                setErrorMessageTasaInteresConsumoBajoMonto('Este campo es requerido');
            } else {
                setErrorTasaInteresConsumo(true);
                setErrorMessageTasaInteresConsumo('Este campo es requerido');
            }
            return false;
        }
        
        // Si es parámetro, es válido sin más validación
        if (value.startsWith('Parámetro')) {
            if (isBajoMonto) {
                setErrorTasaInteresConsumoBajoMonto(false);
                setErrorMessageTasaInteresConsumoBajoMonto('');
            } else {
                setErrorTasaInteresConsumo(false);
                setErrorMessageTasaInteresConsumo('');
            }
            return true;
        }
        
        let numValue;
        if (value === 'Personalizado') {
            const personalizado = isBajoMonto ? tasaInteresConsumoBajoMontoPersonalizado : tasaInteresConsumoPersonalizado;
            if (!personalizado) {
                if (isBajoMonto) {
                    setErrorTasaInteresConsumoBajoMonto(true);
                    setErrorMessageTasaInteresConsumoBajoMonto('Debe ingresar un valor personalizado');
                } else {
                    setErrorTasaInteresConsumo(true);
                    setErrorMessageTasaInteresConsumo('Debe ingresar un valor personalizado');
                }
                return false;
            }
            numValue = parseFloat(personalizado);
        } else {
            numValue = parseFloat(value);
        }
        
        if (isNaN(numValue)) {
            if (isBajoMonto) {
                setErrorTasaInteresConsumoBajoMonto(true);
                setErrorMessageTasaInteresConsumoBajoMonto('Debe ser un número');
            } else {
                setErrorTasaInteresConsumo(true);
                setErrorMessageTasaInteresConsumo('Debe ser un número');
            }
            return false;
        }
        
        if (numValue < 0 || numValue > 100) {
            if (isBajoMonto) {
                setErrorTasaInteresConsumoBajoMonto(true);
                setErrorMessageTasaInteresConsumoBajoMonto('Debe estar entre 0 y 100');
            } else {
                setErrorTasaInteresConsumo(true);
                setErrorMessageTasaInteresConsumo('Debe estar entre 0 y 100');
            }
            return false;
        }
        
        if (isBajoMonto) {
            setErrorTasaInteresConsumoBajoMonto(false);
            setErrorMessageTasaInteresConsumoBajoMonto('');
        } else {
            setErrorTasaInteresConsumo(false);
            setErrorMessageTasaInteresConsumo('');
        }
        return true;
    };

    const handleOpenModal = (index = null) => {
        // Reset errors
        setErrorScoreMinimo(false);
        setErrorScoreMaximo(false);
        setErrorFondoGarantiaConsumo(false);
        setErrorFondoGarantiaConsumoBajoMonto(false);
        setErrorTasaInteresConsumo(false);
        setErrorTasaInteresConsumoBajoMonto(false);
        setErrorMessageScoreMinimo('');
        setErrorMessageScoreMaximo('');
        setErrorMessageFondoGarantiaConsumo('');
        setErrorMessageFondoGarantiaConsumoBajoMonto('');
        setErrorMessageTasaInteresConsumo('');
        setErrorMessageTasaInteresConsumoBajoMonto('');
        
        // Limpiar el índice de error de segmentación
        setErrorSegmentationIndex(null);
        
        if (index !== null) {
            setEditingIndex(index);
            const segmentation = segmentations[index];
            setScoreMinimo(segmentation.scoreMinimo?.toString() || '');
            setScoreMaximo(segmentation.scoreMaximo?.toString() || '');
            setFondoGarantiaConsumo((segmentation.fondoGarantiaConsumo * 100)?.toFixed(2) || '');
            setFondoGarantiaConsumoBajoMonto((segmentation.fondoGarantiaConsumoBajoMonto * 100)?.toFixed(2) || '');
            
            // Convertir de decimal a porcentaje para mostrarlo en el select o input personalizado
            const interesConsumoDecimal = segmentation.interesConsumo * 100;
            const interesConsumoBajoMontoDecimal = segmentation.interesConsumoBajoMonto * 100;
            
            // Verificar si es personalizado usando los flags
            const isPersonalizadoConsumo = segmentation.interesConsumoPersonalizado === true;
            const isPersonalizadoBajoMonto = segmentation.interesConsumoBajoMontoPersonalizado === true;
            
            // Convertir de decimal a porcentaje
            const interesConsumoStr = interesConsumoDecimal.toFixed(2);
            const interesConsumoBajoMontoStr = interesConsumoBajoMontoDecimal.toFixed(2);
            
            if (isPersonalizadoConsumo) {
                setTasaInteresConsumo('Personalizado');
                setTasaInteresConsumoPersonalizado(interesConsumoStr);
            } else {
                if (tasaInteresConsumoParametro) {
                    setTasaInteresConsumo(`Parámetro (${tasaInteresConsumoParametro}%)`);
                } else {
                    setTasaInteresConsumo('Personalizado');
                    setTasaInteresConsumoPersonalizado(interesConsumoStr);
                }
                setTasaInteresConsumoPersonalizado('');
            }
            
            if (isPersonalizadoBajoMonto) {
                setTasaInteresConsumoBajoMonto('Personalizado');
                setTasaInteresConsumoBajoMontoPersonalizado(interesConsumoBajoMontoStr);
            } else {
                if (tasaInteresConsumoBajoMontoParametro) {
                    setTasaInteresConsumoBajoMonto(`Parámetro (${tasaInteresConsumoBajoMontoParametro}%)`);
                } else {
                    setTasaInteresConsumoBajoMonto('Personalizado');
                    setTasaInteresConsumoBajoMontoPersonalizado(interesConsumoBajoMontoStr);
                }
                setTasaInteresConsumoBajoMontoPersonalizado('');
            }
            
            setTasaInteresConsumoType('');
            setTasaInteresConsumoBajoMontoType('');
        } else {
            setEditingIndex(null);
            setScoreMinimo('');
            setScoreMaximo('');
            setFondoGarantiaConsumo('');
            setFondoGarantiaConsumoBajoMonto('');
            setTasaInteresConsumo('');
            setTasaInteresConsumoBajoMonto('');
            setTasaInteresConsumoType('');
            setTasaInteresConsumoBajoMontoType('');
            setTasaInteresConsumoPersonalizado('');
            setTasaInteresConsumoBajoMontoPersonalizado('');
        }
        setIsModal(true);
    };

    const handleCloseModal = () => {
        setIsModal(false);
        setEditingIndex(null);
        setScoreMinimo('');
        setScoreMaximo('');
        setFondoGarantiaConsumo('');
        setFondoGarantiaConsumoBajoMonto('');
        setTasaInteresConsumo('');
        setTasaInteresConsumoBajoMonto('');
        
        // Reset errors
        setErrorScoreMinimo(false);
        setErrorScoreMaximo(false);
        setErrorFondoGarantiaConsumo(false);
        setErrorFondoGarantiaConsumoBajoMonto(false);
        setErrorTasaInteresConsumo(false);
        setErrorTasaInteresConsumoBajoMonto(false);
        setErrorMessageScoreMinimo('');
        setErrorMessageScoreMaximo('');
        setErrorMessageFondoGarantiaConsumo('');
        setErrorMessageFondoGarantiaConsumoBajoMonto('');
        setErrorMessageTasaInteresConsumo('');
        setErrorMessageTasaInteresConsumoBajoMonto('');
    };
    
    const handleClosedSnack = (event, reason) => {
        if(reason == 'clickaway'){
            return;
        }
        setIsSnackbar(false);
    };

    const validateNoOverlap = (min, max, currentIndex = null) => {
        let hasOverlap = false;
        let errorMsg = '';
        
        // Verificar que no haya solapamiento con otras segmentaciones
        for (let i = 0; i < segmentations.length; i++) {
            if (currentIndex !== null && i === currentIndex) continue;
            
            const seg = segmentations[i];
            const segMin = parseInt(seg.scoreMinimo);
            const segMax = parseInt(seg.scoreMaximo);
            
            // Verificar solapamiento
            if ((min >= segMin && min < segMax) || 
                (max > segMin && max <= segMax) ||
                (min <= segMin && max >= segMax)) {
                hasOverlap = true;
                // Determinar el tipo de solapamiento
                if (min >= segMin && min < segMax) {
                    errorMsg = `La segmentación que está creando se solapa con la segmentación ${segMin}-${segMax}. El score mínimo (${min}) debe ser ${segMax + 1} para evitar el solapamiento (ejemplo: si hay 0-299, la siguiente debe empezar en 300)`;
                } else if (max > segMin && max <= segMax) {
                    errorMsg = `La segmentación que está creando se solapa con la segmentación ${segMin}-${segMax}. El score máximo (${max}) debe ser ${segMin - 1} para evitar el solapamiento (ejemplo: si hay 300-599, la anterior debe terminar en 299)`;
                } else {
                    errorMsg = `La segmentación que está creando se solapa completamente con la segmentación ${segMin}-${segMax}. Debe ajustar los rangos para que no se superpongan`;
                }
                break;
            }
        }
        
        return { hasOverlap, errorMsg };
    };

    const validateContinuity = () => {
        const min = parseInt(scoreMinimo);
        const max = parseInt(scoreMaximo);
        
        // Crear una copia temporal con todas las segmentaciones incluyendo la nueva/editada
        const tempSegmentations = [...segmentations];
        
        if (editingIndex !== null) {
            // Si estamos editando, reemplazar la segmentación en el índice correspondiente
            tempSegmentations[editingIndex] = {
                scoreMinimo: min,
                scoreMaximo: max,
                fondoGarantiaConsumo: parseFloat(fondoGarantiaConsumo) / 100,
                fondoGarantiaConsumoBajoMonto: parseFloat(fondoGarantiaConsumoBajoMonto) / 100,
                interesConsumo: parseFloat(tasaInteresConsumo === 'Personalizado' ? tasaInteresConsumoPersonalizado : tasaInteresConsumo) / 100,
                interesConsumoBajoMonto: parseFloat(tasaInteresConsumoBajoMonto === 'Personalizado' ? tasaInteresConsumoBajoMontoPersonalizado : tasaInteresConsumoBajoMonto) / 100,
            };
        } else {
            // Si estamos agregando, agregar la nueva segmentación
            tempSegmentations.push({
                scoreMinimo: min,
                scoreMaximo: max,
                fondoGarantiaConsumo: parseFloat(fondoGarantiaConsumo) / 100,
                fondoGarantiaConsumoBajoMonto: parseFloat(fondoGarantiaConsumoBajoMonto) / 100,
                interesConsumo: parseFloat(tasaInteresConsumo === 'Personalizado' ? tasaInteresConsumoPersonalizado : tasaInteresConsumo) / 100,
                interesConsumoBajoMonto: parseFloat(tasaInteresConsumoBajoMonto === 'Personalizado' ? tasaInteresConsumoBajoMontoPersonalizado : tasaInteresConsumoBajoMonto) / 100,
            });
        }
        
        // Ordenar por scoreMinimo
        const sortedSeg = tempSegmentations.sort((a, b) => parseInt(a.scoreMinimo) - parseInt(b.scoreMinimo));
        
        // Validar que sean continuas
        for (let i = 0; i < sortedSeg.length - 1; i++) {
            
            const currentMax = parseInt(sortedSeg[i].scoreMaximo);
            const nextMin = parseInt(sortedSeg[i + 1].scoreMinimo);
            
            if (currentMax !== nextMin - 1) {
                return { 
                    isContinuous: false, 
                    errorMsg: `Las segmentaciones no son continuas. La segmentación que termina en ${currentMax} y la que comienza en ${nextMin} no son consecutivas. Deben crear segmentaciones intermedias para que sean continuas (ejemplo: si hay una de 0-299 y otra de 600-899, debe crear una de 300-599 entre ellas)`
                };
            }
        }
        
        return { isContinuous: true };
    };

    const handleSave = () => {
        // Validar todos los campos
        let hasErrors = false;
        
        if (!validateScoreMinimo(scoreMinimo)) hasErrors = true;
        if (!validateScoreMaximo(scoreMaximo)) hasErrors = true;
        if (!validateFondoGarantiaConsumo(fondoGarantiaConsumo)) hasErrors = true;
        if (!validateFondoGarantiaConsumoBajoMonto(fondoGarantiaConsumoBajoMonto)) hasErrors = true;
        if (!validateTasaInteres(tasaInteresConsumo, false)) hasErrors = true;
        if (!validateTasaInteres(tasaInteresConsumoBajoMonto, true)) hasErrors = true;
        
        if (hasErrors) {
            setMessage('Por favor corrija los errores en el formulario');
            setSeverity('error');
            setIsSnackbar(true);
            return;
        }

        // Validar que no haya solapamiento
        const min = parseInt(scoreMinimo);
        const max = parseInt(scoreMaximo);
        const overlapValidation = validateNoOverlap(min, max, editingIndex);
        
        if (overlapValidation.hasOverlap) {
            setErrorScoreMinimo(true);
            setErrorMessageScoreMinimo(overlapValidation.errorMsg);
            setErrorScoreMaximo(true);
            setErrorMessageScoreMaximo(overlapValidation.errorMsg);
            setMessage(overlapValidation.errorMsg);
            setSeverity('error');
            setIsSnackbar(true);
            return;
        }

        // Obtener valor final de tasas de interés
        let interesConsumoFinal;
        let interesConsumoBajoMontoFinal;
        let interesConsumoPersonalizadoFlag = false;
        let interesConsumoBajoMontoPersonalizadoFlag = false;

        // Determinar si es personalizado y el valor
        if (tasaInteresConsumo === 'Personalizado') {
            interesConsumoPersonalizadoFlag = true;
            interesConsumoFinal = parseFloat(tasaInteresConsumoPersonalizado) / 100;
        } else {
            interesConsumoPersonalizadoFlag = false;
            // Verificar si es el parámetro
            if (tasaInteresConsumo.startsWith('Parámetro')) {
                interesConsumoFinal = parseFloat(tasaInteresConsumoParametro) / 100;
            } else {
                interesConsumoFinal = parseFloat(tasaInteresConsumo) / 100;
            }
        }

        if (tasaInteresConsumoBajoMonto === 'Personalizado') {
            interesConsumoBajoMontoPersonalizadoFlag = true;
            interesConsumoBajoMontoFinal = parseFloat(tasaInteresConsumoBajoMontoPersonalizado) / 100;
        } else {
            interesConsumoBajoMontoPersonalizadoFlag = false;
            // Verificar si es el parámetro
            if (tasaInteresConsumoBajoMonto.startsWith('Parámetro')) {
                interesConsumoBajoMontoFinal = parseFloat(tasaInteresConsumoBajoMontoParametro) / 100;
            } else {
                interesConsumoBajoMontoFinal = parseFloat(tasaInteresConsumoBajoMonto) / 100;
            }
        }

        const newSegmentation = {
            scoreMinimo: parseInt(scoreMinimo),
            scoreMaximo: parseInt(scoreMaximo),
            fondoGarantiaConsumo: parseFloat(fondoGarantiaConsumo) / 100, // Convertir porcentaje a decimal
            fondoGarantiaConsumoBajoMonto: parseFloat(fondoGarantiaConsumoBajoMonto) / 100, // Convertir porcentaje a decimal
            interesConsumo: interesConsumoPersonalizadoFlag ? interesConsumoFinal : 0,
            interesConsumoBajoMonto: interesConsumoBajoMontoPersonalizadoFlag ? interesConsumoBajoMontoFinal : 0,
            interesConsumoPersonalizado: interesConsumoPersonalizadoFlag,
            interesConsumoBajoMontoPersonalizado: interesConsumoBajoMontoPersonalizadoFlag,
        };

        if (editingIndex !== null) {
            const updated = [...segmentations];
            updated[editingIndex] = newSegmentation;
            // Ordenar las segmentaciones
            updated.sort((a, b) => parseInt(a.scoreMinimo) - parseInt(b.scoreMinimo));
            setSegmentations(updated);
        } else {
            const updated = [...segmentations, newSegmentation];
            // Ordenar las segmentaciones
            updated.sort((a, b) => parseInt(a.scoreMinimo) - parseInt(b.scoreMinimo));
            setSegmentations(updated);
        }
        
        // Limpiar el índice de error de segmentación después de guardar
        setErrorSegmentationIndex(null);
        
        handleCloseModal();
    };

    const handleDelete = (index) => {
        if (segmentations.length <= 1) {
            setMessage('Debe existir al menos una segmentación');
            setSeverity('warning');
            setIsSnackbar(true);
            return;
        }
        
        const updated = segmentations.filter((_, i) => i !== index);
        setSegmentations(updated);
    };

    const [errorSegmentationIndex, setErrorSegmentationIndex] = useState(null);

    const validateContinuityAll = () => {
        setErrorSegmentationIndex(null);
        
        if (segmentations.length <= 1) {
            return { isContinuous: true, index: -1 };
        }
        
        // Ordenar por scoreMinimo
        const sortedSeg = [...segmentations].sort((a, b) => parseInt(a.scoreMinimo) - parseInt(b.scoreMinimo));
        
        // Validar que sean continuas
        for (let i = 0; i < sortedSeg.length - 1; i++) {
            const currentMax = parseInt(sortedSeg[i].scoreMaximo);
            const nextMin = parseInt(sortedSeg[i + 1].scoreMinimo);
            
            if (currentMax !== nextMin - 1) {
                // Encontrar el índice original de la segmentación problemática
                const problemSeg = sortedSeg[i];
                const originalIndex = segmentations.findIndex(seg => 
                    seg.scoreMinimo === problemSeg.scoreMinimo && 
                    seg.scoreMaximo === problemSeg.scoreMaximo
                );
                
                setErrorSegmentationIndex(originalIndex);
                
                return { 
                    isContinuous: false, 
                    index: i,
                    errorMsg: `Las segmentaciones no son continuas. La segmentación ${sortedSeg[i].scoreMinimo}-${sortedSeg[i].scoreMaximo} y ${sortedSeg[i + 1].scoreMinimo}-${sortedSeg[i + 1].scoreMaximo} no son consecutivas. Deben crear segmentaciones intermedias para que sean continuas (ejemplo: si hay una de 0-299 y otra de 600-899, debe crear una de 300-599 entre ellas)`
                };
            }
        }
        
        return { isContinuous: true, index: -1 };
    };

    const handleSaveAll = () => {
        if (segmentations.length === 0) {
            setMessage('No hay segmentaciones para guardar');
            setSeverity('info');
            setIsSnackbar(true);
            return;
        }

        if (!experian) {
            setMessage('Por favor selecciona un tipo de segmentación de Experian');
            setSeverity('warning');
            setIsSnackbar(true);
            return;
        }

        // Validar continuidad
        const continuityValidation = validateContinuityAll();
        
        if (!continuityValidation.isContinuous) {
            setMessage(continuityValidation.errorMsg);
            setSeverity('error');
            setIsSnackbar(true);
            return;
        }

        setIsBackdrop(true);
        
        // Preparar los datos según el formato requerido
        const segmentationsData = segmentations.map(seg => ({
            fondoGarantiaConsumo: typeof seg.fondoGarantiaConsumo === 'string' ? parseFloat(seg.fondoGarantiaConsumo) : (seg.fondoGarantiaConsumo !== undefined ? seg.fondoGarantiaConsumo : 0),
            fondoGarantiaConsumoBajoMonto: typeof seg.fondoGarantiaConsumoBajoMonto === 'string' ? parseFloat(seg.fondoGarantiaConsumoBajoMonto) : (seg.fondoGarantiaConsumoBajoMonto !== undefined ? seg.fondoGarantiaConsumoBajoMonto : 0),
            interesConsumo: typeof seg.interesConsumo === 'string' ? parseFloat(seg.interesConsumo) : seg.interesConsumo,
            interesConsumoBajoMonto: typeof seg.interesConsumoBajoMonto === 'string' ? parseFloat(seg.interesConsumoBajoMonto) : seg.interesConsumoBajoMonto,
            interesConsumoPersonalizado: seg.interesConsumoPersonalizado !== undefined ? seg.interesConsumoPersonalizado : false,
            interesConsumoBajoMontoPersonalizado: seg.interesConsumoBajoMontoPersonalizado !== undefined ? seg.interesConsumoBajoMontoPersonalizado : false,
            scoreMinimo: typeof seg.scoreMinimo === 'string' ? parseInt(seg.scoreMinimo) : seg.scoreMinimo,
            scoreMaximo: typeof seg.scoreMaximo === 'string' ? parseInt(seg.scoreMaximo) : seg.scoreMaximo,
            experian: experian,
        }));

        axiosClient.post('/v1/score-segmentations/replace-all', segmentationsData)
            .then(response => {
                if (response.status === 200) {
                    setIsBackdrop(false);
                    setMessage('Segmentaciones guardadas exitosamente');
                    setSeverity('success');
                    setIsSnackbar(true);
                }
            })
            .catch(error => {
                console.log("Error guardando segmentaciones: " + error.message);
                setIsBackdrop(false);
                setMessage('Error al guardar las segmentaciones. Por favor intenta de nuevo');
                setSeverity('error');
                setIsSnackbar(true);
            });
    };

    return (
        <React.Fragment>
            <CssBaseline />
            <Toolbar />
            <Box sx={{ width: '100%', margin: '18px 14px' }}>
                <Stack spacing={2}>
                    <Item>.</Item>
                    <Item></Item>
                    <Grid container alignItems="center">
                        <Grid item xs={12}>
                            <Box mt={2}>
                                <h1>Scores Segmentación</h1>
                            </Box>
                        </Grid>
                    </Grid>
                    
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, gap: 2 }}>
                        <FormControl sx={{ minWidth: 200 }}>
                            <InputLabel id="experian-label">Experian</InputLabel>
                            <Select
                                labelId="experian-label"
                                id="experian-select"
                                label="Experian"
                                value={experian}
                                onChange={handleChangeExperian}
                            >
                                <MenuItem value="sintesis-pdf">Sintesis PDF</MenuItem>
                                <MenuItem value="mi-decisor">Mi Decisor</MenuItem>
                            </Select>
                        </FormControl>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <ButtonPrincipal 
                                variant="contained" 
                                onClick={getSegmentationsByExperian}
                            >
                                Buscar
                            </ButtonPrincipal>
                            <ButtonPrincipal 
                                variant="contained" 
                                onClick={handleSaveAll}
                            >
                                Guardar
                            </ButtonPrincipal>
                            <ButtonAdd onClick={() => handleOpenModal()}>
                                <AddIcon /> Agregar Segmentación
                            </ButtonAdd>
                        </Box>
                    </Box>
                    
                    {segmentations.length === 0 ? (
                        <Box sx={{ textAlign: 'center', py: 4, backgroundColor: '#f5f5f5', borderRadius: '10px' }}>
                            <Typography variant="body1" color="text.secondary">
                                {hasSearched && experian
                                    ? `No hay segmentaciones configuradas para ${experian === 'sintesis-pdf' ? 'Sintesis PDF' : 'Mi Decisor'}`
                                    : 'Selecciona un tipo de segmentación de Experian y haz clic en Buscar'}
                            </Typography>
                        </Box>
                    ) : (
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">Score Mínimo</TableCell>
                                        <TableCell align="center">Score Máximo</TableCell>
                                        <TableCell align="center">Fondo Garantía Consumo (%)</TableCell>
                                        <TableCell align="center">Fondo Garantías Consumo Bajo Monto (%)</TableCell>
                                        <TableCell align="center">Tasa Interés Consumo (%)</TableCell>
                                        <TableCell align="center">Tasa Interés Bajo Monto (%)</TableCell>
                                        <TableCell align="center">Acciones</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {segmentations.map((segmentation, index) => (
                                        <TableRow 
                                            key={index}
                                            sx={{ 
                                                backgroundColor: errorSegmentationIndex === index ? '#ffebee' : 'inherit',
                                                '&:hover': {
                                                    backgroundColor: errorSegmentationIndex === index ? '#ffcdd2' : '#f5f5f5',
                                                }
                                            }}
                                        >
                                            <TableCell align="center" sx={{ fontWeight: errorSegmentationIndex === index ? 'bold' : 'normal', color: errorSegmentationIndex === index ? '#f44336' : 'inherit' }}>
                                                {segmentation.scoreMinimo}
                                            </TableCell>
                                            <TableCell align="center" sx={{ fontWeight: errorSegmentationIndex === index ? 'bold' : 'normal', color: errorSegmentationIndex === index ? '#f44336' : 'inherit' }}>
                                                {segmentation.scoreMaximo}
                                            </TableCell>
                                            <TableCell align="center">
                                                {segmentation.fondoGarantiaConsumo !== undefined 
                                                    ? `${(segmentation.fondoGarantiaConsumo * 100).toFixed(2)}%`
                                                    : '0.00%'}
                                            </TableCell>
                                            <TableCell align="center">
                                                {segmentation.fondoGarantiaConsumoBajoMonto !== undefined 
                                                    ? `${(segmentation.fondoGarantiaConsumoBajoMonto * 100).toFixed(2)}%`
                                                    : '0.00%'}
                                            </TableCell>
                                            <TableCell align="center">
                                                {segmentation.interesConsumoPersonalizado 
                                                    ? `Personalizado: ${(segmentation.interesConsumo * 100).toFixed(2)}%`
                                                    : `Parámetro (${tasaInteresConsumoParametro || 'N/A'}%)`}
                                            </TableCell>
                                            <TableCell align="center">
                                                {segmentation.interesConsumoBajoMontoPersonalizado 
                                                    ? `Personalizado: ${(segmentation.interesConsumoBajoMonto * 100).toFixed(2)}%`
                                                    : `Parámetro (${tasaInteresConsumoBajoMontoParametro || 'N/A'}%)`}
                                            </TableCell>
                                            <TableCell align="center">
                                                <ButtonEdit onClick={() => handleOpenModal(index)}>
                                                    <EditIcon />
                                                </ButtonEdit>
                                                <ButtonEdit onClick={() => handleDelete(index)} sx={{ color: '#f44336' }}>
                                                    <DeleteIcon />
                                                </ButtonEdit>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </Stack>
            </Box>

            {isModal && (
                <Modal activeModal={isModal} handleModal={handleCloseModal}>
                    <Box sx={{ width: '80%', margin: '1rem auto' }}>
                        <Box textAlign={'center'}>
                            <h2>{editingIndex !== null ? 'Editar Segmentación' : 'Nueva Segmentación'}</h2>
                        </Box>
                        
                        <Box sx={{ mt: 3 }}>
                            <FormControl fullWidth sx={{ mb: 3 }}>
                                <TextField 
                                    label="Score Mínimo" 
                                    variant="outlined" 
                                    value={scoreMinimo} 
                                    onChange={(e) => {
                                        setScoreMinimo(e.target.value);
                                        validateScoreMinimo(e.target.value);
                                    }}
                                    type="number"
                                    error={errorScoreMinimo}
                                    helperText={errorMessageScoreMinimo}
                                    inputProps={{
                                        inputMode: 'numeric',
                                        pattern: '[0-9]*'
                                    }}
                                />
                            </FormControl>
                            
                            <FormControl fullWidth sx={{ mb: 3 }}>
                                <TextField 
                                    label="Score Máximo" 
                                    variant="outlined" 
                                    value={scoreMaximo} 
                                    onChange={(e) => {
                                        setScoreMaximo(e.target.value);
                                        validateScoreMaximo(e.target.value);
                                    }}
                                    type="number"
                                    error={errorScoreMaximo}
                                    helperText={errorMessageScoreMaximo}
                                    inputProps={{
                                        inputMode: 'numeric',
                                        pattern: '[0-9]*'
                                    }}
                                />
                            </FormControl>
                            
                            <FormControl fullWidth sx={{ mb: 3 }}>
                                <TextField 
                                    label="Fondo Garantía Consumo (%)" 
                                    variant="outlined" 
                                    value={fondoGarantiaConsumo} 
                                    onChange={(e) => {
                                        setFondoGarantiaConsumo(e.target.value);
                                        validateFondoGarantiaConsumo(e.target.value);
                                    }}
                                    type="number"
                                    error={errorFondoGarantiaConsumo}
                                    helperText={errorMessageFondoGarantiaConsumo}
                                    inputProps={{
                                        inputMode: 'numeric',
                                        pattern: '[0-9.]*'
                                    }}
                                    sx={{
                                        '& input[type=number]': {
                                            '-moz-appearance': 'textfield'
                                        },
                                        '& input[type=number]::-webkit-outer-spin-button': {
                                            '-webkit-appearance': 'none',
                                            margin: 0
                                        },
                                        '& input[type=number]::-webkit-inner-spin-button': {
                                            '-webkit-appearance': 'none',
                                            margin: 0
                                        }
                                    }}
                                />
                            </FormControl>
                            
                            <FormControl fullWidth sx={{ mb: 3 }}>
                                <TextField 
                                    label="Fondo Garantías Consumo Bajo Monto (%)" 
                                    variant="outlined" 
                                    value={fondoGarantiaConsumoBajoMonto} 
                                    onChange={(e) => {
                                        setFondoGarantiaConsumoBajoMonto(e.target.value);
                                        validateFondoGarantiaConsumoBajoMonto(e.target.value);
                                    }}
                                    type="number"
                                    error={errorFondoGarantiaConsumoBajoMonto}
                                    helperText={errorMessageFondoGarantiaConsumoBajoMonto}
                                    inputProps={{
                                        inputMode: 'numeric',
                                        pattern: '[0-9.]*'
                                    }}
                                    sx={{
                                        '& input[type=number]': {
                                            '-moz-appearance': 'textfield'
                                        },
                                        '& input[type=number]::-webkit-outer-spin-button': {
                                            '-webkit-appearance': 'none',
                                            margin: 0
                                        },
                                        '& input[type=number]::-webkit-inner-spin-button': {
                                            '-webkit-appearance': 'none',
                                            margin: 0
                                        }
                                    }}
                                />
                            </FormControl>
                            
                            <FormControl fullWidth sx={{ mb: 3 }}>
                                <InputLabel id="tasa-interes-consumo-label">Tasa de Interés Consumo %</InputLabel>
                                <Select
                                    labelId="tasa-interes-consumo-label"
                                    id="tasa-interes-consumo"
                                    value={tasaInteresConsumo}
                                    label="Tasa de Interés Consumo %"
                                    onChange={(e) => setTasaInteresConsumo(e.target.value)}
                                >
                                    {tasaInteresConsumoParametro && (
                                        <MenuItem value={`Parámetro (${tasaInteresConsumoParametro}%)`}>
                                            Parámetro ({tasaInteresConsumoParametro}%)
                                        </MenuItem>
                                    )}
                                    <MenuItem value="Personalizado">Personalizado</MenuItem>
                                </Select>
                                {errorTasaInteresConsumo && (
                                    <TextMessage>{errorMessageTasaInteresConsumo}</TextMessage>
                                )}
                            </FormControl>
                            
                            {tasaInteresConsumo === 'Personalizado' && (
                                <FormControl fullWidth sx={{ mb: 3 }}>
                                    <TextField 
                                        label="Valor Personalizado Tasa Interés Consumo %" 
                                        variant="outlined" 
                                        value={tasaInteresConsumoPersonalizado} 
                                        onChange={(e) => setTasaInteresConsumoPersonalizado(e.target.value)}
                                        type="number"
                                        inputProps={{
                                            inputMode: 'numeric',
                                            pattern: '[0-9.]*'
                                        }}
                                    />
                                </FormControl>
                            )}
                            
                            <FormControl fullWidth sx={{ mb: 3 }}>
                                <InputLabel id="tasa-interes-bajo-monto-label">Tasa de Interés Bajo Monto %</InputLabel>
                                <Select
                                    labelId="tasa-interes-bajo-monto-label"
                                    id="tasa-interes-bajo-monto"
                                    value={tasaInteresConsumoBajoMonto}
                                    label="Tasa de Interés Bajo Monto %"
                                    onChange={(e) => setTasaInteresConsumoBajoMonto(e.target.value)}
                                >
                                    {tasaInteresConsumoBajoMontoParametro && (
                                        <MenuItem value={`Parámetro (${tasaInteresConsumoBajoMontoParametro}%)`}>
                                            Parámetro ({tasaInteresConsumoBajoMontoParametro}%)
                                        </MenuItem>
                                    )}
                                    <MenuItem value="Personalizado">Personalizado</MenuItem>
                                </Select>
                                {errorTasaInteresConsumoBajoMonto && (
                                    <TextMessage>{errorMessageTasaInteresConsumoBajoMonto}</TextMessage>
                                )}
                            </FormControl>
                            
                            {tasaInteresConsumoBajoMonto === 'Personalizado' && (
                                <FormControl fullWidth sx={{ mb: 3 }}>
                                    <TextField 
                                        label="Valor Personalizado Tasa Interés Bajo Monto %" 
                                        variant="outlined" 
                                        value={tasaInteresConsumoBajoMontoPersonalizado} 
                                        onChange={(e) => setTasaInteresConsumoBajoMontoPersonalizado(e.target.value)}
                                        type="number"
                                        inputProps={{
                                            inputMode: 'numeric',
                                            pattern: '[0-9.]*'
                                        }}
                                    />
                                </FormControl>
                            )}
                            
                            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 4 }}>
                                <Button 
                                    variant="outlined" 
                                    onClick={handleCloseModal}
                                    sx={{ borderRadius: '20px' }}
                                >
                                    Cancelar
                                </Button>
                                <ButtonPrincipal 
                                    variant="contained" 
                                    onClick={handleSave}
                                >
                                    Guardar
                                </ButtonPrincipal>
                            </Box>
                        </Box>
                    </Box>
                </Modal>
            )}
            
            <Snackbar open={isSnackbar} autoHideDuration={5000} onClose={handleClosedSnack}>
                <Alert onClose={handleClosedSnack} severity={severity} sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
            
            <Backdrop sx={{ background: 'rgba(255,255,255,0.1)', zIndex: '5', width: '50%', margin: 'auto auto auto 30vw' }} open={isBackdrop}>
                <CircularProgress color="success" />
            </Backdrop>
        </React.Fragment>
    );
}